import {Badge} from "@mantine/core";

export default function BonusChip({value}: {value: number}) {
    let color = value > -15 ? 'yellow' : 'green';
    return <Badge className="bonus-chip" color={color} variant="filled">{value}%</Badge>
}
